import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import persist from '@alpinejs/persist'
import focus from '@alpinejs/focus'
import 'focus-visible'
import AOS from 'aos'
import swiper from './components/carousel'
import gsap from './components/titleSlider'
import Player from '@vimeo/player';

// Initialize Animate on Scroll library
AOS.init()

const form = document.querySelector('#form')
const contactButtons = document.querySelectorAll('a.btn[data-type="contact-form"]')

contactButtons.forEach(btn => {
  if (form) {
    btn.addEventListener('click', e => {
      e.preventDefault()

      const yOffset = -80;
      const y = form.getBoundingClientRect().top + window.pageYOffset + yOffset;
      document.body.setAttribute('data-lock-scroll', 0)
      window.scrollTo({ behavior: 'smooth', top: y })
    })
  } else {
    btn.href = btn.href + '#form';
  }
})

// Prevent video from showing below footer on mobile
let video = document.querySelector('.component-hero-video');

if (video) {
  window.addEventListener('scroll', () => {
      if (document.documentElement.scrollTop > window.innerHeight) {
          video.style.visibility = 'hidden';
      } else {
          video.style.visibility = 'visible';
      }
  });

  // Vimeo Player
  let frame = video.querySelector('.video-frame');
  let soundButton = document.querySelector('.play-button');
  let player = new Player(frame);

  let volume = 0;

  soundButton.addEventListener('click', () => {
    volume = volume === 1 ? 0 : 1;
    soundButton.classList.toggle('mute', volume);
    player.setVolume(volume)
  })
}

// Global get CSRF token function (used by forms).
window.getToken = async () => {
  return await fetch('/!/DynamicToken/refresh')
    .then(res => res.json())
    .then(data => {
      return data.csrf_token
    })
    .catch(function (error) {
      this.error = 'Something went wrong. Please try again later.'
    })
}

// Call Alpine.
window.Alpine = Alpine
Alpine.plugin(collapse)
Alpine.plugin(persist)
Alpine.plugin(focus)
Alpine.start()
